/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 11:12:21
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-06 17:03:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/Components/SEOSetting/index.tsx
 */
import { Input, TextArea } from '@/src/components/Antd';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import React, { Fragment } from 'react';
import Slug from 'src/constrains/SlugInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { SectionContent } from 'src/layout/EditorPageLayout/EditorCollapsePageLayout';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { EnumCollapseId } from '../../common';
import { getCollapse, onCollapseChange } from '../../slice/edit';

const SEOSetting = ({
  title,
  handleOnTitleChange,
  description,
  handleOnDescriptionChange,
  urlSlug,
  saleChannelUuid,
  slugValid,
  type,
  uuid,
  handleSlugOnChange,
  isPrimary,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    // <SectionWrapper isHeader title='SEO Setting'>
    <SectionContent>
      <Row
        elements={[
          {
            child: (
              <Fragment>
                <ItemWrapper
                  title={getI18n('productCollection.index.sEOTitle')}
                  rightPart={
                    <CountWords count={(title || '').length} allCount={100} />
                  }>
                  <Input
                    value={title}
                    onChange={handleOnTitleChange}
                    size='large'
                    placeholder={`${getI18n(
                      'productCollection.index.sEOTitle',
                    )}  (0/100)`}
                    maxLength={100}
                    disabled={disabled}
                  />
                </ItemWrapper>
                <ItemWrapper
                  rightPart={
                    <CountWords
                      count={(description || '').length}
                      allCount={500}
                    />
                  }
                  title={getI18n('general.upload.EditModal.description')}>
                  <TextArea
                    value={description}
                    onChange={handleOnDescriptionChange}
                    maxLength={500}
                    placeholder={`${getI18n(
                      'general.upload.EditModal.description',
                    )} (0/500)`}
                    disabled={disabled}
                  />
                </ItemWrapper>
              </Fragment>
            ),
          },
          {
            child: isPrimary ? (
              <Slug
                displayDangerousNotice
                value={urlSlug}
                url={'portal/salesChannel/collection/checkSlug'}
                fixedParams={{
                  salesChannelUuid: saleChannelUuid,
                  uuid: type === 'Duplicate' ? '' : uuid,
                }}
                slugValid={slugValid}
                disabled={disabled}
                onChange={handleSlugOnChange}
              />
            ) : (
              ''
            ),
          },
        ]}
      />
    </SectionContent>
  );
};
export default SectionHOC(SEOSetting, {
  id: EnumCollapseId.SeoSetting,
  title: getI18nFromGeneral('general.hOCTitle.sEOSetting'),
  getCollapse,
  onCollapseChange,
});
